import { types } from "./types"

export const setActiveFormId = payload => dispatch => {
    dispatch({ type: types.SET_ACTIVE_FORM_ID , payload });
  };